import React from 'react';
import { Row, Empty, Typography } from 'antd';
import classes from './ReportsListNoReport.module.scss';

export const ReportsListNoReport = () => {
  return (
    <Row align="middle" justify="center" className={classes.noReportsWrapper}>
      <Empty description={<Typography.Text type="secondary">No created reports</Typography.Text>} />
    </Row>
  );
};
